import { useSnackbar } from "notistack";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Reducers } from "../Interfaces/Interfaces";
import { getAgentByPhone, inviteAgent } from "../redux/actions/AgentActions";
import {
  getAggregatoerByPhone,
  inviteAggregatorAction,
} from "../redux/actions/AggregatorAction";
import PrimaryTheme from "../Themes/Primary";
import Input from "./Input";
import StatusAlert from "./StatusAlert";

export default function ExistingAgent() {
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);
  const getAgentPhoneNumber = useSelector(
    (state: any) => state.agents
  );

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [agentName, setName] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [phoneNumberValid, setPhoneNumberValid]: any = React.useState(null);
  const [submitted] = React.useState(false);
  const [pin] = React.useState("");
  const [agentId, setAgentId]: any = React.useState("");
  const validatePhoneNumber = (text: any) => {
    let reg = /^[0-9]{11,11}$/;
    if (!reg.test(text)) {
      setPhoneNumber(text);
      setPhoneNumberValid(false);
    } else {
      setPhoneNumber(text);
      setPhoneNumberValid(true);
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    dispatch({
      type: "LOADING",
      payload: true,
    });

    dispatch({
      type: "ALERT_MODAL",
      payload: false,
    });

    const agent = {
      
      agentId: agentId,

      inviteMessage: message,
    };

    dispatch(inviteAgent(agent));
  };
  const closeAlert = () => {
    dispatch({ type: "STATUS_ALERT", payload: false });
    setAgentId("");
    setName("");
    setPhoneNumber("");
    setMessage("");
  };

  // const closeModal = () => {
  //   dispatch({ type: "ALERT_MODAL", payload: false })
  // }

  // const handleOTP = (e: any) => {
  //   e.preventDefault();

  //   dispatch({
  //     type: 'ALERT_MODAL',
  //     payload: true
  //   })
  // };

  React.useEffect(() => {
    if (phoneNumber.length === 11) {
      dispatch({
        type: "LOADING",
        payload: true,
      });

      dispatch(getAgentByPhone(phoneNumber));
    }
  }, [dispatch, phoneNumber]);

  React.useEffect(() => {
    if (Object.entries(getAgentPhoneNumber).length !== 0) {
      setName(
        getAgentPhoneNumber.firstName +
          " " +
          getAgentPhoneNumber.lastName
      );
      setAgentId(getAgentPhoneNumber.id);
    }
  }, [getAgentPhoneNumber]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        // enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      } else {
        // handleRefresh();

        if (alert.message === "Successful") {
          dispatch({
            type: "STATUS_ALERT",
            payload: true,
          });
        }

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);

  return (
    <div>
      <form noValidate>
        <h6
          className="text-center"
          style={{
            fontFamily: PrimaryTheme.fonts?.LightFont,
            color: PrimaryTheme.dark,
          }}
        >
          Map a registered Bankly agent to your aggregator account
        </h6>

        <div className="form-group mt-4">
          <label
            htmlFor="phoneNumber"
            style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              color: PrimaryTheme.dark,
            }}
          >
            Enter Agent Phone Number
          </label>
          <Input
            type="tel"
            placeholder="Enter Phone Number"
            autoComplete="phoneNumber"
            showIcon
            required
            id="phoneNumber"
            valid={phoneNumberValid}
            value={phoneNumber}
            disabled={submitted}
            inputMode="tel"
            onChange={(e) => validatePhoneNumber(e.target.value)}
            isInput
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              color: PrimaryTheme.dark,
              background: "#F4F7FC",
            }}
          />
        </div>

        <div className="form-group">
          <label
            htmlFor="name"
            style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              color: PrimaryTheme.dark,
            }}
          >
            Agent Name
          </label>
          <Input
            type="text"
            placeholder="Agent Name"
            autoComplete="name"
            showIcon
            required
            id="name"
            value={agentName}
            disabled
            inputMode="text"
            onChange={(e) => setName(e.target.value)}
            isInput
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              color: PrimaryTheme.dark,
              background: "#F4F7FC",
            }}
          />
        </div>

        <div className="form-group">
          <label
            htmlFor="message"
            style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              color: PrimaryTheme.dark,
            }}
          >
            Message (Optional)
          </label>
          <Input
            type="text"
            placeholder="Message"
            autoComplete="message"
            id="message"
            value={message}
            inputMode="text"
            onChange={(e) => setMessage(e.target.value)}
            isInput
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              color: PrimaryTheme.dark,
              background: "#F4F7FC",
              height: 90,
            }}
          />
        </div>

        <div className="form-group mt-5 col-md-8 ml-auto mr-auto">
          <Input
            onClick={handleSubmit}
            type="button"
            isInput
            value="Continue"
            disabled={agentName === "" ? true : false || !phoneNumberValid}
            style={{
              background: PrimaryTheme.primary,
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              color: PrimaryTheme.white,
            }}
            className="text-bold border-0"
          />
        </div>
      </form>

      <StatusAlert
        subtitle="An email has been sent to the new agent email provided. The email contains a link which the aggregator is expected to accept before being mapped fully to your account."
        title={agentName + " Mapped Successfully"}
        buttonTitle="Add Agent"
        backTitle="Back to dashboard"
        onClick={closeAlert}
      ></StatusAlert>
    </div>
  );
}
